import './result.less';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';

const propTypes = {
	options: PropTypes.array,
	controlName: PropTypes.string,
	onDelete: PropTypes.func,
	intl: PropTypes.func,
	isSubPermission: PropTypes.bool
};

const Result = ({
	options,
	controlName,
	onDelete,
	intl,
	isSubPermission
}) => (
	<div className="permission-control__select-result">
		{ options.map(option => (
			<div key={option.value} className="item">
				<span className={cn('item-title', option.icon)}>{intl(option.label)}</span>
				<span className="remove" onClick={ () => onDelete(controlName, option.value) }/>
			</div>
		))}

		{ options.length === 0 && (
			<div className="item item--empty">
				<span>{isSubPermission ? intl('Select option') : intl('No access to actions')}</span>
			</div>
		) }
	</div>
);

Result.propTypes = propTypes;
export default Result;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/components/permissions/control/result.js